export default {
  latinica: {
    // Dokumenta zaposlenih
    // dodavanjeZaposlenih: "DODAVANJE ZAPOSLENIH",
    // sortiranjeZaposlenih: "SORTIRANJE ZAPOSLENIH",
    // dalje: "DALJE",
    // dodaj: "DODAJ",
    // ime: "IME",
    // srednjeIme: "SREDNJE IME",
    // prezime: "PREZIME",
    // datumRodjenja: "DATUM RODJENJA",
    // adresa: "ADRESA",
    // kontaktTelefon: "KONTAKT TELEFON",
    // emailAdresa: "EMAIL ADRESA",
    // brojLicneKarte: "BROJ LIČNE KARTE",
    // strucnaSprema: "STRUČNA SPREMA",
    // oblastSpreme: "OBLAST SPREME",
    // vozackaDozvola: "VOZAČKA DOZVOLA",
    // maternjiJezik: "MATERNJI JEZIK",
    // odeca: "ODEĆA",
    // obuca: "OBUĆA",
    // radnoMesto: "RADNO MESTO",
    // poslovnaJedinica: "POSL. JEDINICA",
    // pocetakRada: "POČETAK RADA",
    // aktivniZaposleni: "AKTIVNI ZAPOSLENI",
    // eksternoZaposleni: "EKSTERNO ZAPOSLENI",
    // arhiviraniZaposleni: "ARHIVIRANI ZAPOSLENI",
    // ug: "Ug",
    // lk: "Lk",
    // lz: "Lz",
    // dr: "Dr",
    // vazecaDokumenta: "ВАЖЕЋА ДОКУМЕНТА",
    // ugovorORadu: "UGOVOR O RADU",
    // maObrazac: "MA obrazac",
    // uputZaLekarski: "Uput za lekarski",
    // lekarskiIzvestaj: "Lekarski izveštaj",
    // zaduzenjeLZO: "Zaduženje LZO",
    // testBZR: "Test BZR",
    // zapisnikBZR: "Zapisnik BZR",
    // testZOP: "Test ZOP",
    // obrazac6: "Obrazac br. 6",
    // prvaPomoc: "Prva pomoć",
    // dodajNoviDokument: "DODAJ NOVI DOKUMENT",
    // sacuvaj: "SAČUVAJ",
    // odustani: "ODUSTANI",
    // dodajNovi: "DODAJ NOVI",
    // vrstaDokumenta: "VRSTA DOKUMENTA",
    // brojDokumenta: "BROJ DOKUMENTA",
    // vaziOd: "VAŽI OD",
    // vaziDo: "VAŽI DO",
    // dan: "Dan",
    // vrstaUputa: "VRSTA UPUTA",
    // brojUputa: "BROJ UPUTA",
    // mestoRodjenja: "MESTO ROĐENJA",

    // // Sredstva i oprema
    // aktivnaSiO: "AKTIVNA SiO",
    // uTudjemVlasnistvu: "U TUĐEM VLASNIŠTVU",
    // neaktivnaSiO: "NEAKTIVNA SiO",
    // td: "TD",
    // sn: "SN",
    // rg: "RG",
    // pu: "PU",
    // od: "OD",
    // naziv: "NAZIV",
    // tip: "TIP",
    // idBroj: "ID BROJ",
    // oznaka: "OZNAKA",
    // dodavanjeSredstvaIliOpreme: "DODAVANJE SREDSTVA ILI OPREME",
    // sortiranjeSredstvaIOpreme: "SORTIRANJE SREDSTVA I OPREME",
    // vrstaSiO: "VRSTA SiO",
    // pretrazi: "PRETRAŽI",
    // istekDokumenta: "ISTEK DOKUMENTA",
    // pretraga: "Pretraga",
    // model: "MODEL",
    // registracija: "REGISTRACIJA",
    // prikljucniUredjaji: "PRIKLJUČNI UREĐAJI",
    // godinaProizvodnje: "GOD. PROIZVODNJE",
    // nazivSredstva: "NAZIV SREDSTVA",
    // vrstaSredstva: "VRSTA SREDSTVA",
    // vrsta: "VRSTA",
    // lokacija: "LOKACIJA",
    // odgovoranZaStanje: "ODGOVORAN ZA STANJE",
    // ucitajFotografiju: "UČITAJ FOTOGRAFIJU 3:4",
    // istice: "ISTIČE",
    // nepostojiFotografija: "NE POSTOJI FOTOGRAFIJA",
    // izmeniFotografiju: "IZMENI FOTOGRAFIJU 3:4",
    // rb: "R.b.",
    // sadrzaj: "SADRŽAJ",
    // kom: "KOM",
    // prvaPomocOsposobljeni: "PRVA POMOĆ - OSPOSOBLJENI",
    // najblizaSluzbaHitnaPomoc: "NAJBLIŽA SLUŽBA HITNA POMOĆ",
    // najblizaZdravstvenaUstanova: "NAJBLIŽA ZDRAVSTVENA USTANOVA",
    // najbliziCentarZaTrovanja: "NAJBLIŽI CENTAR ZA TROVANJA",
    // najbliziCentarZaOpekotine: "NAJBLIŽI CENTAR ZA OPEKOTINE",
    // najblizaPolicijskaSt: "192 - NAJBLIŽA POLICIJSKA ST.",
    // najblizaVatrogasnaSl: "193 - NAJBLIŽA VATROGASNA SL.",
    // izmeniKontaktPodatke: "IZMENI KONTAKT PODATKE",
    // nazivStavkeKojuDodajete: "NAZIV STAVKE KOJU DODAJETE",
    // komada: "KOMADA",
    // regOzn: "REG. OZN.",
    // vozac: "VOZAČ",
    // inventar: "INVENTAR",
    // PRVAPOMOC: "PRVA POMOĆ",
    // ppAparat: "P.P. APARAT",
    // strucniNalaz: "STRUČNI NALAZ",
    // brojNalaza: "BROJ NALAZA",
    // uputstvo: "UPUTSTVO",
    // MASINA: "MAŠINA",
    // UREDJAJ: "UREĐAJ",
    // ALAT: "ALAT",

    // // Evidencije
    // // Evidencija 6
    // ucitaj: "UČITAJ",
    // ugradi: "UGRADI",
    // resetuj: "RESETUJ",
    // imeIPrezime: "IME I PREZIME",
    // opis: "OPIS",
    // lzo: "LZO",
    // razlog: "RAZLOG",
    // teorija: "TEORIJA",
    // praksa: "PRAKSA",
    // test: "TEST",
    // zapisnik: "ZAPISNIK",
    // rizici: "RIZICI",
    // uputstva: "UPUTSTVA",
    // mereBZR: "MERE BZR",
    // prati: "PRATI",
    // rizik: "RIZIK",
    // primeni: "PRIMENI",
    // unos: "UNOS",
    // stampaj: "ŠTAMPAJ",
    // posalji: "POŠALJI",
    // filtriraj: "FILTRIRAJ",
    // dodatniPoslovi: "DODATNI POSLOVI",
    // datum: "DATUM",
    // sledeci: "SLEDEĆI",

    // // Evidencije 7
    // aktivno: "AKTIVNO",
    // arhivirano: "ARHIVIRANO",
    // kontrola: "KONTROLA",
    // dan: "DAN",
    // nepravilnosti: "NEPRAVILNOSTI",
    // mere: "MERE",
    // napomena: "NAPOMENA",
    // azuriraj: "AŽURIRAJ",
    // tekuciMesec: "TEKUĆI MESEC",
    // prethodniMeseci: "PRETHODNI MESECI",
    // redniBr: "Redni br.",
    // godina: "GODINA",
    // mesec: "MESEC",
    // gradilisteRadiliste: "POSLOVNA JEDINICA ILI GRADILIŠTE/RADILIŠTE",
    // pocetak: "POČETAK",
    // poslednje: "POSLEDNJE",

    // // Procena rizika
    // dodato: "DODATO",
    // arhiviranaDokumenta: "ARHIVIRANA DOKUMENTA",
    // segment: "SEGMENT",
    // nazivDokumenta: "NAZIV DOKUMENTA",
    // confirmDeleteDocumentAllVersions:
    //   "Da li ste sigurni da zelite da obrisete sve verzije dokumenta?",
    // uRedu: "U redu",
    // nepostojecaVerzija:
    //   "Izabrana verzija dokumenta ne postoji. Molimo izaberite drugu verziju.",
    // confirmAddDocument: "Da li ste sigurni da želite da dodate dokument?",
    // confirmAddDocumentImage:
    //   "Da li ste sigurni da želite da dodate sliku dokumenta?",
    // confirmAddDocumentScan:
    //   "Da li ste sigurni da želite da dodate skenirani dokumenta?",
    // warningDeleteOld: "Ovim će se stara verzija dokumenta obrisati.",
    // nazivRadnogMesta: "NAZIV RADNOG MESTA",
    // sprema: "SPREMA",
    // iskustvo: "ISKUSTVO",
    // uslovi: "USLOVI",
    // dokumenta: "DOKUMENTA",
    // nazad: "NAZAD",
    // ponisti: "PONIŠTI",
    // poimenicno: "POIMENIČNO",
    // DA: "DA",
    // NE: "NE",
    // SVE: "SVE",
    // VSS: "VSS",
    // SSS: "SSS",
    // OSS: "OSS",
    // radnoIskustvo: "RADNO ISKUSTVO",
    // posebniUslovi: "POSEBNI USLOVI",
    // straniJezici: "STRANI JEZICI",
    // itVestine: "IT VEŠTINE",
    // dodatniUslovi: "DODATNI USLOVI",
    // prikazi: "PRIKAŽI",
    // izbrisi: "IZBRIŠI",
    // izmeni: "IZMENI",
    // confirmDeleteRadnoMesto:
    //   "Da li ste sigurni da želite da obrišete izabrano radno mesto?",
    // confirmDeleteRadnaMesta:
    //   "Da li ste sigurni da želite da obrišete izabrana radna mesta?",
    // rok: "ROK",
    // povecaniRizik: "POVEĆANI RIZIK",

    // //showBar
    // deleteKorisnik:
    //   "Da li ste sigurni da želite da obrišete izabranog korisnika?",
    // deleteLokacija:
    //   "Da li ste sigurni da želite da obrišete izabranu lokaciju?",
    // brisanjeNijeDozvoljeno: "Brisanje nije dozvoljeno",
    // upravljanje: "УПРАВЉАЊЕ",

    // // poslovne jedinice
    // POSLOVNE_JEDINICE: "POSLOVNE JEDINICE",
    // GRADILISTA: "GRADILIŠTA",
    // RADILISTA: "RADILIŠTA",
    // "POSLOVNA JEDINICA": "POSLOVNA JEDINICA",
    // GRADILISTE: "GRADILIŠTE",
    // RADILISTE: "RADILIŠTE"
    dodavanjeZaposlenih: "ДОДАВАЊЕ ЗАПОСЛЕНИХ",
    sortiranjeZaposlenih: "СОРТИРАЊЕ ЗАПОСЛЕНИХ",
    dalje: "ДАЉЕ",
    dodaj: "ДОДАЈ",
    ime: "ИМЕ",
    srednjeIme: "СРЕДЊЕ ИМЕ",
    prezime: "ПРЕЗИМЕ",
    datumRodjenja: "ДАТУМ РОЂЕЊА",
    adresa: "АДРЕСА",
    kontaktTelefon: "КОНТАКТ ТЕЛЕФОН",
    emailAdresa: "ЕМАИЛ АДРЕСА",
    brojLicneKarte: "БРОЈ ЛИЧНЕ КАРТЕ",
    strucnaSprema: "СТРУЧНА СПРЕМА",
    oblastSpreme: "ОБЛАСТ СПРЕМЕ",
    vozackaDozvola: "ВОЗАЧКА ДОЗВОЛА",
    maternjiJezik: "МАТЕРЊИ ЈЕЗИК",
    odeca: "ОДЕЋА",
    obuca: "ОБУЋА",
    radnoMesto: "РАДНО МЕСТО",
    poslovnaJedinica: "ПОСЛ. ЈЕДИНИЦА",
    pocetakRada: "ПОЧЕТАК РАДА",
    aktivniZaposleni: "АКТИВНИ ЗАПОСЛЕНИ",
    eksternoZaposleni: "ЕКСТЕРНО ЗАПОСЛЕНИ",
    arhiviraniZaposleni: "АРХИВИРАНИ ЗАПОСЛЕНИ",
    ug: "Уг",
    lk: "Лк",
    lz: "Лз",
    dr: "Др",
    vazecaDokumenta: "ВАЖЕЋА ДОКУМЕНТА",
    ugovorORadu: "УГОВОР О РАДУ",
    maObrazac: "МА образац",
    uputZaLekarski: "Упут за лекарски",
    lekarskiIzvestaj: "Лекарски извештај",
    zaduzenjeLZO: "Задужење ЛЗО",
    testBZR: "Тест БЗР",
    zapisnikBZR: "Записник БЗР",
    testZOP: "Тест ЗОП",
    obrazac6: "Образац бр. 6",
    prvaPomoc: "Прва помоћ",
    dodajNoviDokument: "ДОДАЈ НОВИ ДОКУМЕНТ",
    sacuvaj: "САЧУВАЈ",
    odustani: "ОДУСТАНИ",
    dodajNovi: "ДОДАЈ НОВИ",
    vrstaDokumenta: "ВРСТА ДОКУМЕНТА",
    brojDokumenta: "БРОЈ ДОКУМЕНТА",
    vaziOd: "ВАЖИ ОД",
    vaziDo: "ВАЖИ ДО",
    dan: "Дан",
    vrstaUputa: "ВРСТА УПУТА",
    brojUputa: "БРОЈ УПУТА",
    mestoRodjenja: "МЕСТО РОЂЕЊА",

    // Sredstva i oprema
    aktivnaSiO: "AKTIVNA SiO",
    uTudjemVlasnistvu: "U TUĐEM VLASNIŠTVU",
    neaktivnaSiO: "NEAKTIVNA SiO",
    td: "TD",
    sn: "SN",
    rg: "RG",
    pu: "PU",
    od: "OD",
    naziv: "NAZIV",
    tip: "TIP",
    idBroj: "ID BROJ",
    oznaka: "OZNAKA",
    dodavanjeSredstvaIliOpreme: "DODAVANJE SREDSTVA ILI OPREME",
    sortiranjeSredstvaIOpreme: "SORTIRANJE SREDSTVA I OPREME",
    vrstaSiO: "VRSTA SiO",
    pretrazi: "PRETRAŽI",
    istekDokumenta: "ISTEK DOKUMENTA",
    pretraga: "Pretraga",
    model: "MODEL",
    registracija: "REGISTRACIJA",
    prikljucniUredjaji: "PRIKLJUČNI UREĐAJI",
    godinaProizvodnje: "GOD. PROIZVODNJE",
    nazivSredstva: "NAZIV SREDSTVA",
    vrstaSredstva: "VRSTA SREDSTVA",
    vrsta: "VRSTA",
    lokacija: "LOKACIJA",
    odgovoranZaStanje: "ODGOVORAN ZA STANJE",
    ucitajFotografiju: "UČITAJ FOTOGRAFIJU 3:4",
    istice: "ISTIČE",
    nepostojiFotografija: "NE POSTOJI FOTOGRAFIJA",
    izmeniFotografiju: "IZMENI FOTOGRAFIJU 3:4",
    rb: "R.b.",
    sadrzaj: "SADRŽAJ",
    kom: "KOM",
    prvaPomocOsposobljeni: "PRVA POMOĆ - OSPOSOBLJENI",
    najblizaSluzbaHitnaPomoc: "NAJBLIŽA SLUŽBA HITNA POMOĆ",
    najblizaZdravstvenaUstanova: "NAJBLIŽA ZDRAVSTVENA USTANOVA",
    najbliziCentarZaTrovanja: "NAJBLIŽI CENTAR ZA TROVANJA",
    najbliziCentarZaOpekotine: "NAJBLIŽI CENTAR ZA OPEKOTINE",
    najblizaPolicijskaSt: "192 - NAJBLIŽA POLICIJSKA ST.",
    najblizaVatrogasnaSl: "193 - NAJBLIŽA VATROGASNA SL.",
    izmeniKontaktPodatke: "IZMENI KONTAKT PODATKE",
    nazivStavkeKojuDodajete: "NAZIV STAVKE KOJU DODAJETE",
    komada: "KOMADA",
    regOzn: "REG. OZN.",
    vozac: "VOZAČ",
    inventar: "INVENTAR",
    PRVAPOMOC: "PRVA POMOĆ",
    ppAparat: "P.P. APARAT",
    strucniNalaz: "STRUČNI NALAZ",
    brojNalaza: "BROJ NALAZA",
    uputstvo: "UPUTSTVO",
    MASINA: "MAŠINA",
    UREDJAJ: "UREĐAJ",
    ALAT: "ALAT",
    proizvodjac: "PROIZVOĐAČ",
    serijskiBroj: "SERIJSKI BROJ",
    brojPrethodnogStrucnogNalaza: "BROJ PRETHODNOG STRUČNOG NALAZA",
    objekat: "OBJEKAT",
    prethodniStrucniNalaz: "BROJ PRETHODNOG STRUČNOG NALAZA",
    dodajSredstvo: "DODAJ SREDSTVO",
    // Средства и опрема
    aktivnaSiO: "АКТИВНА СиО",
    uTudjemVlasnistvu: "У ТУЂЕМ ВЛАСНИШТВУ",
    neaktivnaSiO: "НЕАКТИВНА СиО",
    td: "ТД",
    sn: "СН",
    rg: "РГ",
    pu: "ПУ",
    od: "ОД",
    naziv: "НАЗИВ",
    tip: "ТИП",
    idBroj: "ИД БРОЈ",
    oznaka: "ОЗНАКА",
    dodavanjeSredstvaIliOpreme: "ДОДАВАЊЕ СРЕДСТВА ИЛИ ОПРЕМЕ",
    sortiranjeSredstvaIOpreme: "СОРТИРАЊЕ СРЕДСТВА И ОПРЕМЕ",
    vrstaSiO: "ВРСТА СиО",
    pretrazi: "ПРЕТРАЖИ",
    istekDokumenta: "ИСТЕК ДОКУМЕНТА",
    pretraga: "Претрага",
    model: "МОДЕЛ",
    registracija: "РЕГИСТРАЦИЈА",
    prikljucniUredjaji: "ПРИКЉУЧНИ УРЕЂАЈИ",
    godinaProizvodnje: "ГОД. ПРОИЗВОДЊЕ",
    nazivSredstva: "НАЗИВ СРЕДСТВА",
    vrstaSredstva: "ВРСТА СРЕДСТВА",
    vrsta: "ВРСТА",
    lokacija: "ЛОКАЦИЈА",
    odgovoranZaStanje: "ОДГОВОРАН ЗА СТАЊЕ",
    ucitajFotografiju: "УЧИТАЈ ФОТОГРАФИЈУ 3:4",
    istice: "ИСТИЧЕ",
    nepostojiFotografija: "НЕ ПОСТОЈИ ФОТОГРАФИЈА",
    izmeniFotografiju: "ИЗМЕНИ ФОТОГРАФИЈУ 3:4",
    rb: "Р.б.",
    sadrzaj: "САДРЖАЈ",
    kom: "КОМ",
    prvaPomocOsposobljeni: "ПРВА ПОМОЋ - ОСПОСОБЉЕНИ",
    najblizaSluzbaHitnaPomoc: "НАЈБЛИЖА СЛУЖБА ХИТНА ПОМОЋ",
    najblizaZdravstvenaUstanova: "НАЈБЛИЖА ЗДРАВСТВЕНА УСТАНОВА",
    najbliziCentarZaTrovanja: "НАЈБЛИЖИ ЦЕНТАР ЗА ТРОВАЊА",
    najbliziCentarZaOpekotine: "НАЈБЛИЖИ ЦЕНТАР ЗА ОПЕКОТИНЕ",
    najblizaPolicijskaSt: "192 - НАЈБЛИЖА ПОЛИЦИЈСКА СТ.",
    najblizaVatrogasnaSl: "193 - НАЈБЛИЖА ВАТРОГАСНА СЛ.",
    izmeniKontaktPodatke: "ИЗМЕНИ КОНТАКТ ПОДАТКЕ",
    nazivStavkeKojuDodajete: "НАЗИВ СТАВКЕ КОЈУ ДОДАЈЕТЕ",
    komada: "КОМАДА",
    regOzn: "РЕГ. ОЗН.",
    vozac: "ВОЗАЧ",
    inventar: "ИНВЕНТАР",
    PRVAPOMOC: "ПРВА ПОМОЋ",
    ppAparat: "П.П. АПАРАТ",
    strucniNalaz: "СТРУЧНИ НАЛАЗ",
    brojNalaza: "БРОЈ НАЛАЗА",
    uputstvo: "УПУТСТВО",
    MASINA: "МАШИНА",
    UREDJAJ: "УРЕЂАЈ",
    ALAT: "АЛАТ",

    // Евиденције
    // Евиденција 6
    ucitaj: "УЧИТАЈ",
    ugradi: "УГРАДИ",
    resetuj: "РЕСЕТУЈ",
    imeIPrezime: "ИМЕ И ПРЕЗИМЕ",
    opis: "ОПИС",
    lzo: "ЛЗО",
    razlog: "РАЗЛОГ",
    teorija: "ТЕОРИЈА",
    praksa: "ПРАКСА",
    test: "ТЕСТ",
    zapisnik: "ЗАПИСНИК",
    rizici: "РИЗИЦИ",
    uputstva: "УПУТСТВА",
    mereBZR: "МЕРЕ БЗР",
    prati: "ПРАТИ",
    rizik: "РИЗИК",
    primeni: "ПРИМЕНИ",
    unos: "УНОС",
    stampaj: "ШТАМПАЈ",
    posalji: "ПОШАЉИ",
    filtriraj: "ФИЛТРИРАЈ",
    dodatniPoslovi: "ДОДАТНИ ПОСЛОВИ",
    datum: "ДАТУМ",
    sledeci: "СЛЕДЕЋИ",

    // Евиденције 7
    aktivno: "АКТИВНО",
    arhivirano: "АРХИВИРАНО",
    kontrola: "КОНТРОЛА",
    dan: "ДАН",
    nepravilnosti: "НЕПРАВИЛНОСТИ",
    mere: "МЕРЕ",
    napomena: "НАПОМЕНА",
    azuriraj: "АЖУРИРАЈ",
    tekuciMesec: "ТЕКУЋИ МЕСЕЦ",
    prethodniMeseci: "ПРЕТХОДНИ МЕСЕЦИ",
    redniBr: "Редни бр.",
    godina: "ГОДИНА",
    mesec: "МЕСЕЦ",
    gradilisteRadiliste: "ПОСЛОВНА ЈЕДИНИЦА ИЛИ ГРАДИЛИШТЕ/РАДИЛИШТЕ",
    pocetak: "ПОЧЕТАК",
    poslednje: "ПОСЛЕДЊЕ",

    // Процена ризика
    dodato: "ДОДАТО",
    arhiviranaDokumenta: "АРХИВИРАНА ДОКУМЕНТА",
    segment: "СЕГМЕНТ",
    nazivDokumenta: "НАЗИВ ДОКУМЕНТА",
    confirmDeleteDocumentAllVersions:
      "Да ли сте сигурни да желите да обришете све верзије документа?",
    uRedu: "У реду",
    nepostojecaVerzija:
      "Изабрана верзија документа не постоји. Молимо изаберите другу верзију.",
    confirmAddDocument: "Да ли сте сигурни да желите да додате документ?",
    confirmAddDocumentImage:
      "Да ли сте сигурни да желите да додате слику документа?",
    confirmAddDocumentScan:
      "Да ли сте сигурни да желите да додате скенирани документа?",
    warningDeleteOld: "Овим ће се стара верзија документа обрисати.",
    nazivRadnogMesta: "НАЗИВ РАДНОГ МЕСТА",
    sprema: "СПРЕМА",
    iskustvo: "ИСКУСТВО",
    uslovi: "УСЛОВИ",
    dokumenta: "ДОКУМЕНТА",
    nazad: "НАЗАД",
    ponisti: "ПОНИШТИ",
    poimenicno: "ПОИМЕНИЧНО",
    DA: "ДА",
    NE: "НЕ",
    SVE: "СВЕ",
    VSS: "ВСС",
    SSS: "ССС",
    OSS: "ОСС",
    radnoIskustvo: "РАДНО ИСКУСТВО",
    posebniUslovi: "ПОСЕБНИ УСЛОВИ",
    straniJezici: "СТРАНИ ЈЕЗИЦИ",
    itVestine: "ИТ ВЕШТИНЕ",
    dodatniUslovi: "ДОДАТНИ УСЛОВИ",
    prikazi: "ПРИКАЖИ",
    izbrisi: "ИЗБРИШИ",
    izmeni: "ИЗМЕНИ",
    confirmDeleteRadnoMesto:
      "Да ли сте сигурни да желите да обришете изабрано радно место?",
    confirmDeleteRadnaMesta:
      "Да ли сте сигурни да желите да обришете изабрана радна места?",
    rok: "РОК",
    povecaniRizik: "ПОВЕЋАНИ РИЗИК",

    //showBar
    deleteKorisnik:
      "Да ли сте сигурни да желите да обришете изабраног корисника?",
    deleteLokacija:
      "Да ли сте сигурни да желите да обришете изабрану локацију?",
    brisanjeNijeDozvoljeno: "Брисање није дозвољено",
    upravljanje: "УПРАВЉАЊЕ",

    // пословне јединице
    POSLOVNE_JEDINICE: "ПОСЛОВНЕ ЈЕДИНИЦЕ",
    GRADILISTA: "ГРАДИЛИШТА",
    RADILISTA: "РАДИЛИШТА",
    "POSLOVNA JEDINICA": "ПОСЛОВНА ЈЕДИНИЦА",
    GRADILISTE: "ГРАДИЛИШТЕ",
    RADILISTE: "РАДИЛИШТЕ",
    zatvori: "ЗАТВОРИ",

    pib: "ПИБ",
    radniNaziv: "РАДНИ НАЗИВ",
    poslovnoIme: "ПОСЛОВНО ИМЕ",
    adresaSedista: "АДРЕСА СЕДИШТА",
    brZaposlenihSifDelatnosti: "БРОЈ ЗАПОСЛЕНИХ И ШИФРА ДЕЛАТНОСТИ",
    matBr: "МАТ. БР",
    arhiviraj: "АРХИВИРАЈ",
    aktiviraj: "АКТИВИРАЈ",
    confirmDeleteKlijent: "Да ли сте сигурни да желите да обришете клијента?"
  },
  cirilica: {}
};
